import wordImg from "./../assets/images/wardImages/ward1.webp";
import wordImg2 from "./../assets/images/wardImages/ward2.webp";
import { wordsAndRooms } from "../data/word/WordsAndRooms";
import { Link } from "react-router-dom";
import { encryptId } from '../components/encryption/encryption';
import BreadcrumbsComponent from "../components/common/BreadcrumbsComponent";

const clickScroller = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};


const BreadCrumbsPath = [
  {
    id: 1,  
    pathName: "Service",
    pathLink: "/service",
  },
  {
    id: 2, 
    pathName: "Ch-ward",
    pathLink: "/service/ch-ward",
  },
];
const WordPage = () => {


  return (
    <>
    <BreadcrumbsComponent  breadCrumbsPath={BreadCrumbsPath}/>

      <div className="relative w-full overflow-hidden lg:block hidden mb-6">
        {/* Images container */}
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 w-full">
            <img
              src={wordImg}
              loading="lazy"
              className="w-full h-auto lg:h-[450px] object-cover"
              alt="Hospital ward"
            />
          </div>
          <div className="lg:w-1/2 w-full">
            <img
              src={wordImg2}
              loading="lazy"
              className="w-full h-auto lg:h-[450px] object-cover"
              alt="Hospital room"
            />
          </div>
        </div>

        {/* Gradient overlay - shows only on lg screens */}
        <div className="hidden lg:block absolute left-0 top-0 bottom-0 w-3/4 bg-gradient-to-r from-blue-800 via-blue-400/50 to-transparent pointer-events-none"></div>
        {/* Content overlay */}

        <div className="flex flex-row">
          <div className="w-full bg-green-700 py-3"></div>
          <div className="w-11/12 absolute top-0 left-0 h-full flex items-center justify-start p-4 lg:p-9">
            <div className="text-center lg:text-left flex flex-row gap-1 items-center">
              <div className="bg-orange-900 py-20 px-2" />
              <h1 className="text-3xl lg:text-7xl Blinker-SemiBold mb-4 lg:mb-6 text-white">
                Hospital Wards and <br />
                Rooms
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* grid view */}

      <div className="flex justify-center px-5 mb-6  py-6 ">
        <div className="flex justify-center  mb-6  py-6  w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8  w-full">
            {wordsAndRooms.map((room: any) => (
              <div
                key={room.id}
                className=" rounded-md overflow-hidden shadow-lg bg-white transition-transform duration-300 hover:scale-105 "
              >
                {/* Room Image with Text Overlay */}
                <div className="relative">
                  {/* Image with full width/height */}
                  <img
                    className="w-full lg:h-96 h-64 object-cover"
                    src={room.mainImage}
                    alt={room.roomType}
                    loading="lazy"
                  />

                  {/* Gradient overlay at bottom only */}
                  <div className="  absolute bottom-0 top-0 right-0 w-full bg-gradient-to-t from-orange-800 lg:via-orange-400/10 via-orange-400/40  to-transparent pointer-events-none"></div>
                  <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent pointer-events-none"></div>

                  {/* Content container fixed to bottom */}
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-2">
                      {/* Text content */}
                      <div className="text-white">
                        <h3 className="text-2xl Blinker-SemiBold leading-tight">
                          {room.roomType}
                        </h3>
                        <p className="text-gray-200">
                          <span className="Blinker-SemiBold">Size:</span>{" "}
                          {room.roomSize}
                        </p>
                        <p className="text-blue-300 Blinker-SemiBold text-xl">
                          {room.fromPrice}
                        </p>
                      </div>

                      {/* Button - stays right-aligned on desktop */}
                      <Link to={`/service/ch-ward/ward-details/${encryptId(room.id)}`}>
                        <button onClick={clickScroller} className="bg-blue-500 hover:bg-blue-600 text-white text-sm py-2 px-4 rounded transition-colors duration-300 w-full lg:w-auto">
                          See more
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WordPage;
